import React, {useState} from 'react'
import {FaBars, FaTimes, FaGithub, FaLinkedin} from 'react-icons/fa'
import { HiOutlineMail } from 'react-icons/hi'
import {BsFillPersonLinesFill} from 'react-icons/bs'
import logo from '../assets/logo.png'
import {Link} from 'react-scroll'

const NavBar = () => {
    const [nav,setNav] = useState(false)
    const handleClick = () => setNav(!nav)
  return (
    <div className='fixed w-full h-[80px] flex justify-between items-center px-4 bg-[#586D80] text-gray-300'>
        <div>
            <img src={logo} alt="my-logo" style={{width:'70px'}}/>
        </div>
        {/* menu */}
          <ul className='hidden md:flex'>
            <li>
              <Link to="home" smooth={true}  duration={500}>
              Home
              </Link>
            </li>
            <li>
              <Link to="about" smooth={true}  duration={500}>
              About
              </Link>
            </li>
            <li>
              <Link to="skills" smooth={true}  duration={500}>
              Skills
              </Link>
            </li>
            <li>
              <Link to="projects" smooth={true}  duration={500}>
              Projects
              </Link>
            </li>
            <li>          
              <Link to="contact" smooth={true}  duration={500}>
              Contact Me
              </Link>
            </li>
          </ul>
        {/* Toggle */}
          <div className='md:hidden z-10' onClick={handleClick}>
            {!nav ? <FaBars /> : <FaTimes/>}
          </div>
          {/* Mobile Menu */}
          <div className= {!nav ? 'hidden' : 'absolute top-0 left-0 w-full h-screen bg-[#586D80] flex flex-col justify-center items-center'}>
            <ul>
              <li className='py-6 text-4xl'>
              <Link onClick={handleClick} to="home" smooth={true}  duration={500}>
              Home
              </Link>
              </li>
              <li className='py-6 text-4xl'>
              <Link onClick={handleClick} to="about" smooth={true}  duration={500}>
              About
              </Link>
              </li>
              <li className='py-6 text-4xl'>
              <Link onClick={handleClick} to="skills" smooth={true}  duration={500}>
              Skills
              </Link>
              </li>
              <li className='py-6 text-4xl'>
              <Link onClick={handleClick} to="projects" smooth={true}  duration={500}>
              Projects
              </Link>
              </li>
              <li className='py-6 text-4xl'>
              <Link onClick={handleClick} to="contact" smooth={true}  duration={500}>
              Contact Me
              </Link>
              </li>
            </ul>
          </div>

          {/* Social icons */}
          <div className='hidden lg:flex fixed flex-col top-[35%] left-0'>
            <ul>
              <li className='w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-[#53565C]'>
                <a className='flex justify-between items-center w-full text-gray-300'
                href="https://www.linkedin.com/in/huaiqinghan-7015/">LinkedIn <FaLinkedin size={30}/></a>
              </li>
              <li className='w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-[#333333]'>
                <a className='flex justify-between items-center w-full text-gray-300'
                href="https://github.com/AldrichHan-CN">GitHub <FaGithub size={30}/></a>
              </li>
              <li className='w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-[#CC5F5A]'>
                <a className='flex justify-between items-center w-full text-gray-300'
                href="mailto:info@korobeiniki.me">Email <HiOutlineMail size={30}/></a>
              </li>
              <li className='w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-[#565f69]'>
                <a className='flex justify-between items-center w-full text-gray-300'
                href='Resume.pdf'>Resume <BsFillPersonLinesFill size={30}/></a>
              </li>
            </ul>
          </div>
    </div>
  )
}

export default NavBar